import { css } from "@emotion/react";
import {
  fontSize,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import {
  accentColor,
  borderColor,
} from "main/javascripts/styles/base/colorStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

// Editor/Postの両方で使用している
export const themeStyleTabiChat = css`
  .editor__h2 {
    font-size: ${fontSize.headline};
    line-height: ${lineHeight.headline1};
    &:after {
      content: "";
      width: calc(100% - 6rem);
      height: 0.25rem;
      background-color: ${borderColor.primaryLightColor};
      border-left: 6rem solid ${accentColor.primaryColor};
    }
    ${moreThanBreakpoint("tablet")} {
      font-size: 1.625rem;
      line-height: 1.5;
    }
  }
  .editor__h3 {
    font-size: 1.1875rem;
    line-height: 1.5;
    &:before {
      width: 0.25rem;
      min-width: 0.25rem;
    }
    ${moreThanBreakpoint("tablet")} {
      font-size: 1.4375rem;
      line-height: 1.5;
    }
  }
  .editor__h4 {
    font-size: ${fontSize.mediumHeading};
    line-height: ${lineHeight.mediumHeadline1};
    ${moreThanBreakpoint("tablet")} {
      font-size: ${fontSize.headline};
      line-height: ${lineHeight.headline1};
    }
  }
`;
